import { render, staticRenderFns } from "./BankAsServer.vue?vue&type=template&id=635f7a8b&scoped=true"
import script from "./BankAsServer.vue?vue&type=script&lang=js"
export * from "./BankAsServer.vue?vue&type=script&lang=js"
import style0 from "./BankAsServer.vue?vue&type=style&index=0&id=635f7a8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635f7a8b",
  null
  
)

export default component.exports